import apiClient from "@/api/apiClient";

const state = {
    isLoggedIn: false,
    user: null,
    loginRedirectRoute: null, // Route the user tried to go to while not logged in, should be redirected after logging in.
}

const getters = {
}

const actions = {
    login({commit}, { username, password, _remember_me }) {
        commit('SET_AUTH_STATE', { isLoggedIn: false})
        return apiClient.post('/login', JSON.stringify({ username, password, _remember_me }))
            .then(response => {
                if (response.status === 200) {
                    commit('SET_AUTH_STATE', {isLoggedIn: true, user: response.data })
                    return true;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            })
    },
    forgotPassword(_, { username }) {
        return apiClient.post('/forgot-password', { username })
            .then(response => {
                if (response.status === 200) {
                    return true;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            })
    },
    validateResetPasswordToken(_, { token }) {
        return apiClient.post('/reset-password/'+token+'/validate')
            .then(response => {
                if (response.status === 200) {
                    return response.data.valid;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            }).catch(error => {
                console.error(error);
                return false;
            });
    },
    resetPassword(_, { token, password }) {
        return apiClient.post('/reset-password/'+token, { password })
            .then(response => {
                if (response.status === 200) {
                    return true;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            })
    },
    // updatePassword(_, { currentPassword, newPassword }) {
    //     return apiClient.post('/update-password', { currentPassword, newPassword })
    //         .then(response => {
    //             if (response.status === 200) {
    //                 return true;
    //             } else {
    //                 console.error(response.data.error);
    //                 return false;
    //             }
    //         })
    // },
    updateUser(_, { firstName, lastName, schoolGroup, school, schoolFunction, currentPassword, newPassword }) {
        return apiClient.post('/update-user', { firstName, lastName, schoolGroup, school, schoolFunction, currentPassword, newPassword })
            .then(response => {
                if (response.status === 200) {
                    return true;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            })
    },
    getUser({commit}) {
        return apiClient.post('/login')
            .then(response => {
                if (response.status === 200) {
                    commit('SET_USER', {user: response.data })
                    return true;
                } else {
                    console.error(response.data.error);
                    return false;
                }
            })
    },
    logout({commit}) {
        // TODO: Ook cookie verwijderen
        commit('CLEAR_AUTH_STATE');
    },
    setLoginRedirectRoute({commit}, route) {
        commit('SET_LOGIN_REDIRECT_ROUTE', route);
    }
}

const mutations = {
    SET_AUTH_STATE(state, { isLoggedIn, user }) {
        state.isLoggedIn = isLoggedIn;
        state.user = user;
    },
    SET_USER(state, { user }) {
        state.user = user;
    },
    SET_LOGIN_REDIRECT_ROUTE(state, route) {
        state.loginRedirectRoute = route;
    },
    CLEAR_AUTH_STATE(state) {
        state.isLoggedIn = null;
        state.user = null;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
